export enum TAG_TYPE {
    'all' = 'all',
    'more' = 'more',
    'colors' = 'colors',
}
